import styles from '../../styles/emailTemplateCard.module.css'
import { cn } from '@/lib/utils/helpers'
import { formatWorkflowLabel } from '../../utils/formatWorkflowLabel'
import type { EmailTemplateAddEditFormProps } from '../../types/components'
import { EmailTemplateFieldError } from './EmailTemplateFieldError'
import { EmailTemplateFormSection } from './EmailTemplateFormSection'

export function EmailTemplateWorkflowSection({ page }: EmailTemplateAddEditFormProps) {
  const {
    workflows,
    loadingList,
    registerField,
    errors,
    varSource,
    showFieldError,
    fieldErrorMessage,
  } = page

  return (
    <EmailTemplateFormSection testId="et-section-workflow" title="Workflow">
      <div className={styles.formRow}>
        <div className={cn(styles.formCol, styles.formColHalf, 'min-w-0')}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel} htmlFor="et-wf">
              Select workflow <span className={styles.requiredStar}>*</span>
            </label>
            <div className={styles.selectWrap}>
              <select
                id="et-wf"
                className={cn(
                  styles.customFormControl,
                  errors.fk_workflow_id && '!border-red-500',
                )}
                disabled={loadingList}
                {...registerField('fk_workflow_id')}
              >
                <option value="">Select workflow</option>
                {workflows.map((w) => (
                  <option key={w.workflow_id} value={String(w.workflow_id)}>
                    {formatWorkflowLabel(w.workflow_type || '')}
                  </option>
                ))}
              </select>
            </div>
            <EmailTemplateFieldError
              show={showFieldError('fk_workflow_id')}
              message={fieldErrorMessage('fk_workflow_id')}
            />
            {varSource?.workflow_description && (
              <p className="mt-2 text-sm text-slate-600">
                Workflow description: {varSource.workflow_description}
              </p>
            )}
          </div>
        </div>
      </div>
    </EmailTemplateFormSection>
  )
}
